<template>
  <div class="page">
    <div class="top-bar"><div class="back" @click="back">返回</div>《{{pageTitle}}》</div>
    <div class="toolbar">

      <div class="button" type="button" @click="scaleX()">缩小</div>
      <div class="button" type="button" @click="scaleD()">放大</div>
    </div>
    <div class="pdf-view"
         ref="pdf">
      <pdf
        v-for="i in numPages"
        :key="i"
        :src="pdfSrc"
        :page="i"
        style="width: 100%"
      ></pdf>
    </div>
    <div :class="['readed', agreed==1?'agreed':'']" v-if="isApplicant==1"  @click="hasRead">已 阅 知</div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory";
var obj = require("@/api/api.js");
export default {
  name: "agreeContent",
  components:{
    pdf
  },
  data() {
    return {
      pdfSrc: '/static/InsuranceClause.pdf',
      numPages: 0,
      scale: 100,
      pageTitle:'',
      agreed:0,
      isApplicant:''
    }
  },
  created() {
    this.isApplicant =this.$route.query.isApplicant
    this.agreed = this.$route.query.agreed
    this.pageTitle = this.$route.query.name
    console.log( this.isApplicant)
  },
  methods:{
    hasRead(){
      let queryParam = this.$route.query
      if(queryParam.agreed==1)return
      let { saveHouseholdReadlnfo } = obj;
      let param = {
        proposalno:queryParam.proposalno,
        phoneno:queryParam.phoneno,
        eletype:queryParam.type
      }


      this.$http
        .post(saveHouseholdReadlnfo, param)
        .then((res) => {
          var result = res.data;
          console.log(result.code)
          if (result.code == "0000") {
            this.agreed = 1
            this.back()
          }
        });
    },
    back(){
      this.$router.go(-1)
    },
    //放大
    scaleD() {
      this.scale += 25;
      this.$refs.pdf.style.width = parseInt(this.scale) + "%";
    },
    //缩小
    scaleX() {
      if (this.scale <= 100) {
        this.scale = 100
        return;
      }
      this.scale -= 25;
      console.log(this.scale)
      this.$refs.pdf.style.width = parseInt(this.scale) + "%";
    },
  },

  beforeRouteLeave(to,from,next){
    this.$destroy()
    next()
  },
  beforeRouteEnter(to, from, next) {
    // 路由守卫刚刚进入是没有实例化界面的，不能使用this
    let queryParam = to.query
    console.log()
    next(vm => {
        let { printProposalH5 } = obj;
        console.log(queryParam)
        vm.$http
          .post(printProposalH5, { proposalno:queryParam.proposalno,phone:queryParam.phoneno,type:queryParam.type })
          .then((res) => {
            var result = res.data;
            if (result.code == "0000") {
              vm.pdfSrc = pdf.createLoadingTask({
                url: `data:application/pdf;base64,${result.data.base64str}`, CMapReaderFactory() {
                  const CMapReader = new CMapReaderFactory();
                  this.fetch = function (query) {
                    return CMapReader.fetch(query).then((data) => {
                      return {
                        // 重建一个Uint8Array，修复第二次打开不能显示后端动态添加文字的问题
                        cMapData: new Uint8Array(data.cMapData),
                        compressionType: data.compressionType,
                      };
                    });
                  };
                }
              })
              vm.pdfSrc.promise.then(respdf => {
                vm.numPages = respdf.numPages
              })


            }
          });

    })
  },

}
</script>

<style scoped>
  .iframe{
    width: 100%;
    height: 90vh
  }
  .page{
    background-color: #FFFFFF;
    padding-bottom: 1px;
  }
  .top-bar{
    width: 100vw;
    height: 45px;
    background: #44dc00;
    background:linear-gradient(#44dc00, #36af00);
    font-size: 16px;
    text-align: center;
    line-height: 45px;
    position: fixed;
    z-index: 100;
    top: 0;
    color: #FFFFFF;
  }
  .back{
    position: absolute;
    color: #FFFFFF;
    width: 60px;
    left: 5px;
    font-size: 16px;
    top: 5px;
    line-height: 35px;
    height: 35px;
  }
  .pdf-view{
    margin-top: 60px;
  }
  .toolbar{
    width: 100vw;
    height: 50px;
    background: linear-gradient(#017a0a, #569554);
    position: sticky;
    top: 45px;
    left: 0;
    z-index: 10000;
    align-items: center;
    justify-content: center;
    display:flex;
  }
  .toolbar .button{
    width: 120px;
    text-align: center;
    font-size: 14px;
    margin: 10px;
    height: 30px;
    line-height: 30px;
    background-color: #daf8cc;
    color: #288400;
    border-radius: 5px;
    border-color: #ffffff;
  }
  .readed{
    margin: 60px 30px ;
    width: calc(100% - 60px);
    height: 45px;
    border: 0;
    text-align: center;
    line-height: 45px;
    border-radius: 5px;
    background-color: #60be31;
    color: #fff;
    font-size: 16px;
    -webkit-appearance: none;

  }
  .agreed{
    background-color: #8a8a8a !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Agreement/agreeContent.vue